import api from '../../service/apiService';
import { apiUrl } from '../../constants/apiUrl';
import { logKafka, catchJSException, logToKibanna } from '../../service/logService';
import { InHomeUtils } from '../../util/change/inhomeUtils';
import { Pages } from './../../constants/actionType';
import { redirectTo } from './redirection';
import { BuildProduct } from './../../constants/actionType';
let kafkaPageLogs = apiUrl().kafkaPageLogs;
let kafkaErrorAppLogs= apiUrl().kafkaErrorAppLogs;
export const submitOrder = (visitId, dispatch, pageName = 'common', flowType = null) => {
    try {
        dispatch({
            type: 'LOADER_ACTIVE',
            value: { isLoaderActive: true, isLoaderText: "submitting  order...", isLoaderImg: "loader" }
        });
        logKafka("INFO", "submitorder", "submitting  order", kafkaErrorAppLogs, "applogs", visitId);
        let url = apiUrl().submitOrder;
        if(window.location.search?.includes('MN=Y') || (window && window.sessionStorage && (window.sessionStorage.getItem('isMidnight') === 'true'))) {
          url = url + '?isMnFlow=Y';
        } 
        const isRetailFiosReferralCheck = window.sessionStorage.getItem('fiosReferralFlow');
        const closingAgencyId = window.sessionStorage.getItem('closingAgencyId')
        const closingSalesCode = window.sessionStorage.getItem('closingSalesCode');
        if(isRetailFiosReferralCheck){
          const query = `closingAgencyId=${closingAgencyId}&closingSalesCode=${closingSalesCode}&posLocationCode=`
          let queryString = url.includes('?isMnFlow=Y') ? '&' : '?'
          queryString = queryString + query
          url = url + queryString
        }
        logToKibanna(`Inhome:submitOrder:common:${url}`, "INFO");
        const message =  sessionStorage.getItem("hostedAttractLoop") ? "fios-common-shell-order" : "fios-bau-order"
        logToKibanna(`Inhome:submitOrder:type:${message}`, "INFO")
        api(url, 'GET','').then(response => {
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && 
                InHomeUtils.isNotNull(response.meta.code) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                    logKafka("INFO", "submitorder", "submitting  order success", kafkaErrorAppLogs, "applogs", visitId);
                dispatch({
                    type: 'SUBMIT_ORDER_RESPONSE',
                    value: response.data
                });                 
            }
            else if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && 
                InHomeUtils.isNotNull(response.meta.code) && InHomeUtils.getIndexOf(response.meta.code, '500.01')) {
                    logKafka("INFO", "submitorder", "submitting  order failed", kafkaErrorAppLogs, "applogs", visitId);
                dispatch({
                    type: 'SUBMIT_ORDER_RESPONSE',
                    value: null
                });
            }
            redirectTo(Pages.confirmation, dispatch);
        })        
        .catch(error => {
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            logKafka("ERROR", "submitorder", "Exception is: " + error.message, kafkaErrorAppLogs, "applogs", visitId);
        });
    }
    catch (ex) {
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        catchJSException(pageName, visitId, 'submitorder', ex);
    }
}

export const onMobileInputChangeEmerg = (data, dispatch, buildProduct, emergencyServicesEmail) => {
    let validMobile = false
    const formattedNumber = data && data.split('.').join('');
    const isInValidSequence = /^([0-9])\1*$/.test(formattedNumber);
    if(data && data != "000-000-0000" && data.length===12 && !isInValidSequence){
      validMobile = true
    }
    let mobileObj = { value: data, mobileValid: validMobile }
    dispatch({ type: 'EMERGENCY_SERVICES_CHANGE_MOBILE', value: mobileObj });
    
    if(buildProduct.emergencyServices.notificationMethod==='both'){
      if(validMobile && buildProduct.emergencyServices.isValidMail){
        if(buildProduct.emergencyServices.accordionStatus!== 'added'){
          dispatch({ type: 'EMERGENCY_SERVICES_CHANGE_ACCOR_STATUS', value: 'added' })};
      }
      else if(buildProduct.emergencyServices.accordionStatus!== 'required'){
        dispatch({ type: 'EMERGENCY_SERVICES_CHANGE_ACCOR_STATUS', value: 'required' });
      }
    }
    else{
      if(validMobile){
        if(buildProduct.emergencyServices.accordionStatus!== 'added'){
          dispatch({ type: 'EMERGENCY_SERVICES_CHANGE_ACCOR_STATUS', value: 'added' })};
      }
      else if(buildProduct.emergencyServices.accordionStatus!== 'required'){
        dispatch({ type: 'EMERGENCY_SERVICES_CHANGE_ACCOR_STATUS', value: 'required' });
      }
    }
}

export const updateContactInfo = (dispatch, contactInfo) => {
  dispatch({ type: BuildProduct.updateContactInfo, value: contactInfo })
};

export const emailErr = (isValidaEmail, dispatch) => {
  let status=({eMailErr:isValidaEmail?"Please enter a valid email address":"", isValidMail:!isValidaEmail})
  let dispatchType = BuildProduct.updateContactInfo;
  dispatch({type: dispatchType, value: status});
  if(isValidaEmail) {
    dispatch({ type: 'EMERGENCY_SERVICES_CHANGE_ACCOR_STATUS', value: 'required' });

  }

};

export const manualEmailValidation = (emailVal, dispatch)=>{
    try{
      let url = apiUrl().manualEmailValidationURL;
      let request = {
          action: "manual",
          email: emailVal,
          prospectCustomer: true
      };
      dispatch({type: "UPDATE_CLICK_FLAG", value: true })
      api(url, 'POST', JSON.stringify(request)).then(response => {
          console.log("Manual validation requst sent")
      }).catch(error => {
          console.log('Manual Email validation error');
          dispatch({type: "UPDATE_CLICK_FLAG",value: false })
      });
  }
  catch(ex){
      console.log('Manul Email validation error');
      dispatch({type: "UPDATE_CLICK_FLAG",value: false })
  }

}
export const emailValidation = (data,pageNameVal,dispatch,buildProduct) => {
  try{
    let url = apiUrl().emailValidationURL;
    let emailVal= data;
    let request = {
        emailAddress: emailVal,
        pageName: pageNameVal
    }
    return new Promise((resolve, reject) => {
        if(emailVal === ""){
            resolve('InValid');
            return;
        }
        api(url, 'POST', JSON.stringify(request)).then(response => {
            if(InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') && InHomeUtils.isNotNull(response.data)){  
              if(response.data.validationStatus){

                    dispatch({type: 'UPDATE_EMAIL_VALIDATION',value: response.data.validationStatus })
                    if(response.data.validationStatus === "Valid" || response.data.validationStatus === "White_listed"){
                        emailErr(false, dispatch);
                        resolve('Valid');
                    }
                    else if(response.data.validationStatus === "Fake" || response.data.validationStatus === "Invalid"){
                        emailErr(true, dispatch);
                        resolve('InValid');
                    }
                    else if(response.data.validationStatus === "maxAttempts" || response.data.validationStatus === "MaxAttempts"  || response.data.validationStatus === "Max_attempts"){
                      emailErr(true, dispatch);
                      dispatch({type: 'UPDATE_EMAIL_VALIDATION',value: "maxAttempts" })
                      resolve('InValid');
                  }
                    else if(response.data.validationStatus === "Manual_validation"){
                        emailErr(true, dispatch);
                        resolve('InValid');
                    }
                }
            }
            else{
                emailErr(false, dispatch);
                resolve('Valid');
            }
        })
        .catch(error => {
            console.log('Email validation error');
            emailErr(false, dispatch);
            resolve('Valid');
        });
    });
    }
    catch(ex){
        console.log('Email validation error',ex);
        emailErr(false, dispatch);
    }

}
export const onEmailInputChangeEmerg = (data, dispatch, buildProduct, emergencyServicesMobile) => {
 
  let emailobj = { value: data.value, emailValid: data.isValidMail};
  dispatch({ type: 'EMERGENCY_SERVICES_CHANGE_EMAIL', value: emailobj });
      if(buildProduct.emergencyServices.notificationMethod==='both'){
        if(data.isValidMail && emergencyServicesMobile.mobileValid){
          if(buildProduct.emergencyServices.accordionStatus!== 'added'){
            dispatch({ type: 'EMERGENCY_SERVICES_CHANGE_ACCOR_STATUS', value: 'added' })};
        }
        else if(buildProduct.emergencyServices.accordionStatus!== 'required'){
          dispatch({ type: 'EMERGENCY_SERVICES_CHANGE_ACCOR_STATUS', value: 'required' });
        }
      }
      else{
        
        if(data.isValidMail){
          if(buildProduct.emergencyServices.accordionStatus!== 'added'){
            dispatch({ type: 'EMERGENCY_SERVICES_CHANGE_ACCOR_STATUS', value: 'added' })};
        }
        else if(buildProduct.emergencyServices.accordionStatus!== 'required'){
          dispatch({ type: 'EMERGENCY_SERVICES_CHANGE_ACCOR_STATUS', value: 'required' });
        }
      } 
}